import {
  GameId,
  TimeTableDay,
  teaserTimeTable,
} from '@/config/home/teaserTimeTable';
import {
  getDateFormat,
  getDateParseFormat,
  getNow,
  parse,
  toLocaleString,
} from '@/utilities/dateUtils';

export function findHomeTeaserTimeslot(
  gameId: GameId,
  now = getNow()
): TimeTableDay | null {
  const today = toLocaleString(now, getDateFormat('Dayname'), {});
  const date = toLocaleString(now, getDateFormat('Default'), {});
  const days = teaserTimeTable.getDays();
  const slot = days.find((item) => {
    const start = parse(
      `${date} ${item.start}`,
      getDateParseFormat('DateAndTime')
    );
    const end = parse(`${date} ${item.end}`, getDateParseFormat('DateAndTime'));
    return (
      item.game === gameId &&
      item.day === today &&
      now.toMillis() <= end.toMillis() &&
      now.toMillis() >= start.toMillis()
    );
  });
  return slot || null;
}
